import { render, staticRenderFns } from "./studentDetail.vue?vue&type=template&id=a8b97ea0&scoped=true&"
import script from "./studentDetail.vue?vue&type=script&lang=js&"
export * from "./studentDetail.vue?vue&type=script&lang=js&"
import style0 from "./studentDetail.vue?vue&type=style&index=0&id=a8b97ea0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8b97ea0",
  null
  
)

export default component.exports